import React from "react";
import {Switch, Route} from "react-router-dom";
import CreateAccount from "../components/home/main/session/CreateAccount";
import Login from "../components/home/main/session/Login";
import Recover from "../components/home/main/session/Recover";
import NewPassword from "../components/home/main/session/NewPassword";

function MainRoutes() {

    return (
        <Switch>
            <Route path={"/main/login"} component={Login}/>
            <Route path={"/main/create-account"} component={CreateAccount}/>
            <Route path={"/main/recover-password"} component={Recover}/>
            <Route path={"/main/new-password"} component={NewPassword}/>
        </Switch>
    )
}

export default MainRoutes;
